import { gql } from '@apollo/client';

export * from './softwareEscrows.query.generated';

export const SOFTWARE_ESCROWS = gql`
  query softwareEscrows(
    $page: Int
    $order: QueryOrderEnum
    $perPage: Int
    $status: EscrowStatusFilterEnum
    $query: String
    $escrowParty: EscrowPartyTypeEnum
  ) {
    softwareEscrows(
      page: $page
      order: $order
      perPage: $perPage
      status: $status
      query: $query
      escrowParty: $escrowParty
    ) {
      nodes {
        id
        currentCompanyRole
        changesRequested
        agreement {
          id
          approved
          approvedByBeneficiary
          approvedByDepositor
          approvedByCodekeeper
          agreementForm
          policy {
            approve
          }
        }
        escrowInvitation {
          status
          companyName
          id
          partyType
          user {
            id
            name
            email
            phone
          }
          policy {
            accept
            reject
            update
          }
          escrow {
            id
          }
        }
        startedBy
        depositStatus
        status
        escrowInvitation {
          ...EscrowInvitationFields
        }
        escrowTermination {
          status
          terminateAt
        }
        beneficiary {
          id
          companyName
          companyWebsite
        }
        depositor {
          id
          companyName
          companyWebsite
        }
        policy {
          remove
        }
        createdAt
        adminReviewAt
        onboardingAt
        signedAt
        activatedAt
        certificationVerified
        certificationCertified
        lastDeposit
        userUpdatedAt
        pendingActivation
      }
      nodesCount
      pagesCount
      hasNextPage
      hasPreviousPage
    }
  }
`;
